<template>
  <div>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h3>Accredited Members</h3>
        <span class="description"></span>
      </el-col>
      <el-col :span="8" class="text-right">
        <el-button type="primary" @click="searchMemberDialogVisible = true">Add</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>

    <el-dialog
      title="Search Members"
      :visible.sync="searchMemberDialogVisible"
      width="90%"
    >
      <el-row :gutter="50">
        <!-- two columns -->
        <el-col :span="12">
          <el-row type="flex" justify="end">
            <el-col :span="6" class="d-flex flex-justify-end mr-4">
              <el-input
                placeholder="ID"
                prefix-icon="el-icon-search"
                v-model="criteria.id"
                clearable
                @keyup.native.enter="searchCriteria"
              >
              </el-input>
            </el-col>
            <el-col :span="8" class="d-flex flex-justify-end mr-4">
              <el-input
                placeholder="Type First Name..."
                prefix-icon="el-icon-search"
                v-model="criteria.firstName"
                clearable
                @keyup.native.enter="searchCriteria"
              >
              </el-input>
            </el-col>
            <el-col :span="10" class="d-flex flex-justify-end">
              <el-input
                placeholder="Type Last Name..."
                prefix-icon="el-icon-search"
                v-model="criteria.lastName"
                clearable
                @keyup.native.enter="searchCriteria"
              >
              </el-input>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="30" justify="end" class="mt-2">
            <el-col :span="19" class="d-flex">
              <el-input
                placeholder="Type an email address..."
                prefix-icon="el-icon-search"
                v-model="criteria.email"
                clearable
                @keyup.native.enter="searchCriteria"
              >
              </el-input>
            </el-col>
            <el-col :span="5" class="d-flex flex-justify-end">
              <el-button type="primary" icon="el-icon-search" @click="searchCriteria">Search</el-button>
            </el-col>
          </el-row>
          <data-tables-server
            :table-props="{
              border: false,
              'hightlight-current-row': true,
              'max-height': 800
            }"
            :pagination-props="{
              pageSizes: [20, 50, 100],
              pagerCount: 5,
              layout:'prev, pager, next, sizes'
            }"
            :current-page.sync="page"
            :page-size="pageSize"
            hightlight-current-row
            :data="filteredTableData"
            :total="total"
            @row-click="handleCurrentChange"
            @query-change="queryChange"
            class="mt-1"
          >
            <el-table-column prop="_id" label="ID" width="120" sortable/>
            <el-table-column prop="profile.firstName" min-width="120" label="First Name" sortable/>
            <el-table-column prop="profile.lastName" min-width="150" label="Last Name"  sortable/>
            <el-table-column prop="profile.email" label="Email" width="250" sortable/>
          </data-tables-server>
        </el-col>
        <el-col :span="12">
          <h3>Selected Members</h3>
          <el-table
            :data="selectedMembers"
            stripe
            class="mt-1"
          >
            <el-table-column prop="_id" label="ID" width="90" />
            <el-table-column prop="profile.firstName" label="First Name" min-width="150"/>
            <el-table-column prop="profile.lastName" label="Last Name" min-width="150"/>
            <el-table-column prop="profile.email" label="Email" min-width="250"/>
            <el-table-column label="Actions" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-delete" @click="removeSelectedMember(scope.row)">Remove</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-button
            v-if="selectedMembers.length > 0"
            type="primary"
            class="mt-2"
            @click="bulkAddMembers"
          >
            Add Members
          </el-button>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelMemberDialog">Cancel</el-button>
      </span>
    </el-dialog>

    <el-table
      :data="members"
      stripe
      class="mt-1"
      @row-click="goToRow"
    >
      <el-table-column prop="member._id" label="ID" width="90" fixed />
      <el-table-column prop="member.profile.firstName" label="First Name" min-width="150"/>
      <el-table-column prop="member.profile.lastName" label="Last Name" min-width="150"/>
      <el-table-column prop="isActive" label="Status" width="120">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.isActive"
            placeholder="Active"
            :disabled="!editingRows[scope.$index]"
            filterable
            @change="updateMemberStatus(scope.row, scope.$index)"
          >
            <el-option :value="true" label="Active"></el-option>
            <el-option :value="false" label="Inactive"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="expiry" label="Expiry" min-width="150" :formatter="dateFormatter"/>
      <el-table-column prop="addedBy" label="Added" min-width="150">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.addedBy" type="info">Added</el-tag>
          <el-tag v-else type="success">Regular</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="expiry" label="Expiry" min-width="150" :formatter="dateFormatter"/>
      <el-table-column label="Added By" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.addedBy">
            {{ scope.row.addedBy.profile.firstName }} {{ scope.row.addedBy.profile.lastName }}
          </span>
          <span v-else></span>
        </template>
      </el-table-column>

      <el-table-column prop="member.profile.email" label="Email" min-width="250"/>
      <el-table-column prop="member.profile.gender" label="Gender" min-width="150"/>
      <el-table-column prop="member.profile.dob" label="DOB" min-width="150" :formatter="dateFormatter"/>
      <el-table-column label="Operations" width="250" fixed="right">
        <template slot-scope="scope">
          <el-tooltip content="Documents" placement="top">
            <el-button type="primary" size="mini" class="px-1" @click.stop="openDocumentDrawer(scope.row)">
              <fa-icon :icon="['fal', 'folder']"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="Edit" placement="top">
            <el-button type="primary" size="mini" class="px-1" @click.stop="editMember(scope.$index)">
              <fa-icon :icon="['fal', editingRows[scope.$index] ? 'check' : 'pen-to-square']"/>
            </el-button>
          </el-tooltip>
          <el-tooltip placement="top">
        <div slot="content">
              <span>Download Accreditation Card</span>
            </div>
            <span style="margin-left: 10px">
              <el-dropdown size="mini" @command="downloadAccreditationCard">
            <el-button type="primary" size="mini">
              <i class="el-icon-postcard"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item :command="{value: scope.row, type:'pdf'}">Download as PDF</el-dropdown-item>
              <el-dropdown-item :command="{value: scope.row, type:'png'}" >Download as PNG</el-dropdown-item>
              <el-dropdown-item :command="{value: scope.row, type:'qr-code'}" >Show QR Code</el-dropdown-item>
              <el-dropdown-item :command="{value: scope.row, type:'regenerate'}" >Regenerate</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </el-tooltip>

        </template>
      </el-table-column>
    </el-table>

    <el-drawer
      title="Member Documents"
      :visible.sync="documentDrawerVisible"
      size="60%"
    >
      <DocumentUploadDialog
        :dialogVisible.sync="uploadDialogVisible"
        @fileUploaded="handleFileUpload"
        @closeDialog="closeDocumentDrawer"
      />
      <el-table :data="memberDocuments" :key="key" class="mt-2">
        <el-table-column prop="fileName" label="Document Name" />
        <el-table-column prop="fileType" label="Document Type" />
        <el-table-column prop="createdAt" label="Uploaded At" :formatter="dateFormatter"/>
        <el-table-column label="Verified">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.verified" active-text="Yes" inactive-text="No" @change="updateDocumentVerification(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button type="success" @click="downloadDocument(scope.row)">Download</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog
      :title="`Qr Code for accreditation card`"
      :visible.sync="showQrCodeDialog"
      width="30%"
      >
      <div style=" overflow-x: auto; width:100%">
        <div class="d-flex justify-content-center">
          <img :src="qrCode" alt="QR Code" />
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { timedate } from '@/utils/timedate';
import { clientNationalIds } from '@/utils/client-rules';
import _ from 'lodash';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment-timezone';
import DocumentUploadDialog from './AccreditationUploadDialog.vue';

export default {
  name: 'AccreditationMembers',
  props: ['value'],
  components: {
    DocumentUploadDialog,
  },
  data() {
    return {
      members: [],
      selectedMembers: [],
      allMembers: [],
      searchMemberDialogVisible: false,
      pageSize: 20,
      page: 1,
      total: 0,
      tableData: [],
      criteria: {
        id: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
      },
      documentDrawerVisible: false,
      uploadDialogVisible: false,
      memberDocuments: [],
      currentMember: null,
      editingRows: {},
      key: 0,
      showQrCodeDialog: false,
      qrCode: null,
    };
  },
  mounted() {
    this.$store.commit('loading', true);
    this.$http.get(`assemble/api/v1/admin/accreditations/${this.value._id}/members`)
      .then((res) => {
        this.members = res.data.data;
        this.$store.commit('loading', false);
      })
      .catch((error) => {
        this.$store.commit('loading', false);
        this.$message.error(error.response.data.message);
      });
  },
  methods: {
    closeDocumentDrawer() {
      this.documentDrawerVisible = false;
    },
    // Function to split text into lines based on the maximum width
    splitTextIntoLines(ctx, text, maxWidth) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const { width } = ctx.measureText(`${currentLine} ${word}`);

        if (width < maxWidth) {
          currentLine += ` ${word}`;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }

      lines.push(currentLine);
      return lines;
    },
    async generateMSCard(membershipDetails, memberProfilePics, entityPic) {
      const cardCanvas = document.createElement('canvas');
      cardCanvas.width = 500;
      cardCanvas.height = 300;
      const cardWidth = cardCanvas.width;
      const pageHeight = cardCanvas.height;
      const cardContext = cardCanvas.getContext('2d');
      const lineSpacing = 22;
      const columnSpacing = 260;
      const lineWidth = 2;
      let isLogoURL = false;
      let isProfileURL = false;
      let isEntityURL = false;

      // Modern color scheme
      const colors = {
        primary: '#1a237e', // Deep blue for primary elements
        secondary: '#303F9F', // Lighter blue for secondary elements
        text: '#2c3e50', // Dark blue-grey for text
        lightText: '#5c6b7f', // Lighter text color
        accent: '#3949ab', // Accent color for highlights
        divider: '#e0e6ed', // Light grey for dividers
        background: '#ffffff' // White background
      };

      let logoImage;
      let profileImage;
      let entityImage;
      let logoPromise;
      let profilePromise;
      let entityPromise;
      const dobFormat = +process.env.VUE_APP_NATIONAL_ID === 15 ? 'YYYY' : 'DD/MM/YYYY'; // Add this line

      // Load Logo Image
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        isLogoURL = true;
      }
      if (memberProfilePics && memberProfilePics !== '') {
        isProfileURL = true;
      }
      if (entityPic && entityPic !== '') {
        isEntityURL = true;
      }

      const additionalFields = membershipDetails.additionalFields || [];
      const memberMeta = membershipDetails.memberMeta || {};

      if (isLogoURL) {
        const logoContent = await this.$http.post('/assemble/api/v1/admin/registrations/image-content', { logo: process.env.VUE_APP_LOGO, isURL: true });
        logoImage = new Image();
        logoImage.src = logoContent.data.data.imageContent;
        logoPromise = new Promise((resolve) => logoImage.onload = resolve);
      }
      if (isProfileURL) {
        const profileContent = await this.$http.post('/assemble/api/v1/admin/registrations/image-content', { memberProfile: memberProfilePics, isURL: true });
        profileImage = new Image();
        profileImage.src = profileContent.data.data.memberImageContent;
        profilePromise = new Promise((resolve) => profileImage.onload = resolve);
      }
      if (isEntityURL) {
        const entityContent = await this.$http.post('/assemble/api/v1/admin/registrations/image-content', { entityLogo: entityPic, isURL: true });
        entityImage = new Image();
        entityImage.src = entityContent.data.data.entityImageContent;
        entityPromise = new Promise((resolve) => entityImage.onload = resolve);
      }

      await Promise.all([logoPromise, profilePromise, entityPromise]);

      // Draw card background with subtle gradient
      const gradient = cardContext.createLinearGradient(0, 0, cardWidth, pageHeight);
      gradient.addColorStop(0, colors.background);
      gradient.addColorStop(1, '#f8f9fa');

      cardContext.fillStyle = gradient;
      cardContext.beginPath();
      // Increased border radius for modern look
      const borderRadius = 25;
      cardContext.moveTo(borderRadius, 0);
      cardContext.lineTo(cardWidth - borderRadius, 0);
      cardContext.quadraticCurveTo(cardWidth, 0, cardWidth, borderRadius);
      cardContext.lineTo(cardWidth, pageHeight - borderRadius);
      cardContext.quadraticCurveTo(cardWidth, pageHeight, cardWidth - borderRadius, pageHeight);
      cardContext.lineTo(borderRadius, pageHeight);
      cardContext.quadraticCurveTo(0, pageHeight, 0, pageHeight - borderRadius);
      cardContext.lineTo(0, borderRadius);
      cardContext.quadraticCurveTo(0, 0, borderRadius, 0);
      cardContext.closePath();
      cardContext.fill();

      // Add subtle shadow effect
      cardContext.beginPath();
      cardContext.moveTo(borderRadius, 0);
      cardContext.lineTo(cardWidth - borderRadius, 0);
      cardContext.quadraticCurveTo(cardWidth, 0, cardWidth, borderRadius);
      cardContext.lineTo(cardWidth, pageHeight - borderRadius);
      cardContext.quadraticCurveTo(cardWidth, pageHeight, cardWidth - borderRadius, pageHeight);
      cardContext.lineTo(borderRadius, pageHeight);
      cardContext.quadraticCurveTo(0, pageHeight, 0, pageHeight - borderRadius);
      cardContext.lineTo(0, borderRadius);
      cardContext.quadraticCurveTo(0, 0, borderRadius, 0);
      cardContext.closePath();
      cardContext.strokeStyle = colors.primary; // or '#000000' for black border
      cardContext.lineWidth = 2;
      cardContext.stroke();

      cardContext.imageSmoothingEnabled = true;
      cardContext.imageSmoothingQuality = 'high';

      // Draw member profile logo
      const profileLogoWidth = 100;
      const profileLogoHeight = 100;
      const profileLogoX = 10;
      const profileLogoY = 10;
      cardContext.globalAlpha = 1;
      if (profileImage) {
        cardContext.drawImage(profileImage, profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      } else {
        cardContext.fillStyle = '#f5f5f5';
        cardContext.fillRect(profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      }

      // Draw entity logo
      const entityLogoWidth = 100;
      const entityLogoHeight = 100;
      const entityLogoX = cardWidth - entityLogoWidth - 10;
      const entityLogoY = 10;

      if (entityImage) {
        cardContext.drawImage(entityImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      } else {
        cardContext.drawImage(logoImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      }

      // Draw entity text
      const maxLineWidth = 260;
      cardContext.font = 'bold 22px "Helvetica Neue", Arial, sans-serif';
      cardContext.fillStyle = colors.primary;
      const textStartX = profileLogoX + profileLogoWidth + 10;
      const entityTextY = profileLogoY + 20;

      const firstLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedFirstLevelLimited, maxLineWidth);
      firstLevelLines.slice(0, 2).forEach((line, index) => {
        cardContext.fillText(line, textStartX, entityTextY + (index * 25));
      });

      const secondLevelStartY = entityTextY + (firstLevelLines.length * 25) + 5;
      cardContext.font = '16px "Helvetica Neue", Arial, sans-serif';
      cardContext.fillStyle = colors.lightText;

      if (membershipDetails.entityCreatedSecondLevelLimited) {
        const secondLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedSecondLevelLimited, maxLineWidth);
        secondLevelLines.slice(0, 2).forEach((line, index) => {
          cardContext.fillText(line, textStartX, secondLevelStartY + (index * 20));
        });
      }

      // Draw accreditation name and description
      const accreditationY = pageHeight - 165;
      cardContext.fillStyle = colors.primary;
      cardContext.font = 'bold 22px "Helvetica Neue", Arial, sans-serif';
      const accreditationNameLines = this.splitTextIntoLines(cardContext, membershipDetails.accreditationName, 450);
      accreditationNameLines.forEach((line, index) => {
        cardContext.fillText(line, 10, accreditationY + index * lineSpacing);
      });

      // Add description
      cardContext.font = '16px "Helvetica Neue", Arial, sans-serif';
      cardContext.fillStyle = colors.lightText;
      const description = membershipDetails.description || '';
      const truncatedDescription = description.length > 60 ? `${description.substring(0, 57)}...` : description;
      cardContext.fillText(truncatedDescription, 10, accreditationY + lineSpacing);

      // Draw sections with modern styling
      const sectionHeaderY = pageHeight - 100;
      cardContext.font = '600 18px "Helvetica Neue", Arial, sans-serif';
      cardContext.fillStyle = colors.primary;
      cardContext.fillText('Accreditation Details', 10, sectionHeaderY);
      cardContext.fillText('Member Details', columnSpacing, sectionHeaderY);

      // Add subtle section dividers
      cardContext.beginPath();
      cardContext.moveTo(10, sectionHeaderY + 5);
      cardContext.lineTo(240, sectionHeaderY + 5);
      cardContext.moveTo(columnSpacing, sectionHeaderY + 5);
      cardContext.lineTo(cardWidth - 10, sectionHeaderY + 5);
      cardContext.strokeStyle = colors.divider;
      cardContext.lineWidth = 2;
      cardContext.stroke();

      // Draw details
      const detailsStartY = sectionHeaderY + lineSpacing;
      cardContext.font = '16px "Helvetica Neue", Arial, sans-serif';

      // First column - Accreditation Details
      cardContext.fillStyle = colors.lightText;
      cardContext.fillText('Expiry:', 10, detailsStartY);
      cardContext.fillStyle = colors.text;
      cardContext.fillText(membershipDetails.expiry, 10 + cardContext.measureText('Expiry: ').width, detailsStartY);

      // Additional fields
      let currentDetailY = detailsStartY + lineSpacing;
      additionalFields.forEach((field) => {
        if (field.displayOnCard) {
          const fieldValue = memberMeta[field.name] || memberMeta[field.label] || '';
          if (currentDetailY < pageHeight - 30) {
            cardContext.fillStyle = colors.lightText;
            cardContext.fillText(`${field.label}:`, 10, currentDetailY);
            cardContext.fillStyle = colors.text;
            cardContext.fillText(fieldValue.toString(), 10 + cardContext.measureText(`${field.label}: `).width, currentDetailY);
            currentDetailY += lineSpacing;
          }
        }
      });

      // Second column - Member Details
      const memberDetails = [
        { label: 'Name', value: membershipDetails.memberName },
        { label: 'Member ID', value: membershipDetails.memberId },
        { label: 'Member Number', value: membershipDetails.memberNumber },
        {
          label: dobFormat === 'YYYY' ? 'Year of Birth' : 'DOB',
          value: moment(membershipDetails.memberDob).format(dobFormat)
        }
      ];

      memberDetails.forEach((detail, index) => {
        cardContext.fillStyle = colors.lightText;
        cardContext.fillText(`${detail.label}:`, columnSpacing, detailsStartY + index * lineSpacing);
        cardContext.fillStyle = colors.text;
        cardContext.fillText(detail.value,
          columnSpacing + cardContext.measureText(`${detail.label}: `).width,
          detailsStartY + index * lineSpacing);
      });

      // Vertical divider with gradient
      const dividerGradient = cardContext.createLinearGradient(0, sectionHeaderY, 0, currentDetailY);
      dividerGradient.addColorStop(0, colors.divider);
      dividerGradient.addColorStop(1, '#ffffff00');
      cardContext.beginPath();
      cardContext.moveTo(columnSpacing - 20, sectionHeaderY);
      cardContext.lineTo(columnSpacing - 20, currentDetailY);
      cardContext.strokeStyle = dividerGradient;
      cardContext.lineWidth = 1;
      cardContext.stroke();

      // Add subtle watermark
      cardContext.globalAlpha = 0.03;
      cardContext.drawImage(logoImage, 0, 0, cardWidth, pageHeight);
      cardContext.globalAlpha = 1;

      return new Promise((resolve) => {
        cardCanvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/png');
      });
    },
    handleAccreditationCardNotFound(val, action, change) {
      const { value: accreditation } = val;
      let msCard;
      let confirmText = 'Accreditation card is not available yet. Do you want to generate it now?';
      if (change) {
        confirmText = 'Accreditation details have been updated. Select yes to generate a new Accreditation Card.';
      }
      if (action === 'regenerate') {
        confirmText = 'Do you want to regenerate the Accreditation Card?';
      }
      this.$confirm(confirmText, 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then(async () => {
          console.log('accreditationss', accreditation);
          const currMember = accreditation.member;
          const currentSeason = this.$store.getters['season/currentSeason'];
          const currMemberProfilePic = _.get(currMember, 'meta.imgUrl');
          const entityPic = _.get(accreditation, 'regoEntity.meta.imgUrl');
          const { orgtree } = accreditation.accreditation;
          console.log('orgtree', orgtree);
          console.log('currMember', currMember);

          // Manually create an array in the desired order from lowest to highest
          const orderedOrgtree = [
            orgtree.club, // Start with the lowest level
            orgtree.association,
            orgtree.state,
            orgtree.national
          ].filter((org) => org !== undefined); // This will remove any undefined levels, in case some levels do not exist
          console.log('orderedOrgtree', orderedOrgtree);

          const entityCreatedFirstLevel = orderedOrgtree[0] ? orderedOrgtree[0].name : '';
          const entityCreatedSecondLevel = orderedOrgtree[1] ? orderedOrgtree[1].name : '';
          const entityCreatedFirstLevelLimited = entityCreatedFirstLevel.length > 67 ? `${entityCreatedFirstLevel.substring(0, 67)}...` : entityCreatedFirstLevel;
          const entityCreatedSecondLevelLimited = entityCreatedSecondLevel.length > 77 ? `${entityCreatedSecondLevel.substring(0, 77)}...` : entityCreatedSecondLevel;

          // Reverse the array to start from club and then move up, and take the first two entities
          // const entityCreated = orderedOrgtree.slice(0, 2).map((org) => org.name).join(', ');
          // console.log('entityCreated length', entityCreated.length);
          // const entityCreatedLimited = entityCreated.length > 45 ? `${entityCreated.substring(0, 45)}...` : entityCreated;
          const accreditationDetails = {
            accreditationName: accreditation.fromImport ? 'Legacy Accreditation' : accreditation.accreditation.name,
            accreditationId: accreditation.fromImport ? '0' : accreditation._id,
            expiry: moment(_.get(accreditation, 'expiry')).format('DD/MM/YYYY'),
            memberType: _.capitalize(accreditation.memberType),
            season: currentSeason,
            memberId: accreditation.member._id,
            memberName: `${currMember.profile.firstName} ${currMember.profile.lastName}`,
            memberDob: currMember.profile.dob,
            memberNumber: _.get(currMember, 'meta.memberNumber', ''),
            entityCreatedFirstLevelLimited,
            entityCreatedSecondLevelLimited,
            deregistered: accreditation.deregistered,
            expired: accreditation.expired,
            additionalFields: accreditation.accreditation.additionalFields,
            memberMeta: accreditation.meta,
            description: accreditation.accreditation.description,
          };
          console.log('accreditationDetails', accreditationDetails);

          this.$store.commit('loading', true);
          msCard = await this.generateMSCard(accreditationDetails, currMemberProfilePic, entityPic);
          console.log('card', msCard);
          console.log('accreditationDetails', accreditationDetails);
          // get presigned url
          const presignedUrl = await this.$http.post('/assemble/api/v1/admin/accreditation-card/presigned-url',
            {
              fileName: `accreditation-card-${accreditation._id}-${accreditation.member._id}.png`,
              folder: 'accreditation-cards',
              accreditationDetails,
              accreditationId: accreditation._id,
              regenerating: !!change,
            });

          const { url, s3Path } = presignedUrl.data.data;
          this.$store.commit('loading', false);

          if (s3Path) {
            _.assign(accreditation, { accreditationCard: s3Path });
          }

          await fetch(url, {
            method: 'PUT',
            body: msCard,
            headers: { 'Content-Type': '*/*' },
          });
          this.$message.success('Membership card generated successfully');
          if (action === 'showQRCode') {
            const findMsCard = await this.$http.get(`/assemble/api/v1/admin/accreditations/${accreditation._id}/members/${accreditation.member._id}/accreditation-card`);
            if (_.get(findMsCard, 'data.msCard.meta.qrCode')) {
              this.qrCode = findMsCard.data.msCard.meta.qrCode;
              this.showQrCodeDialog = true;
            }
          }
          if (msCard) {
            this.downloadAccreditationCard(val, true);
          }
        })
        .catch(async () => {
          if (change) {
            await this.downloadAccreditationCard(val, true);
          }
        });
    },
    async downloadAccreditationCard(val, skipCheck) {
      // console.log(type);
      const { type, value: accreditation } = val;
      console.log('accreditation', accreditation);
      console.log('memberId', accreditation.memberId);
      if (!(skipCheck === true)) {
        const msCardRes = await this.$http.get(`/assemble/api/v1/admin/accreditations/${accreditation._id}/members/${accreditation.member._id}/accreditation-card`);
        this.msCard = msCardRes.data.data;
        const msCardDetails = msCardRes.data.msCard;
        console.log('msCardDetails', msCardDetails);
        if (msCardDetails?.meta?.qrCode) {
          this.qrCode = msCardDetails.meta.qrCode;
        }
        const hasMsCard = this.msCard && this.msCard !== '';
        if (!hasMsCard) {
          this.handleAccreditationCardNotFound(val);
          return;
        }
        if (type === 'regenerate') {
          this.handleAccreditationCardNotFound(val, 'regenerate');
          return;
        }
        if (msCardDetails) {
          // check meta field newChange
          if (msCardDetails.meta.newChange) {
            this.handleAccreditationCardNotFound(val, 'download', msCardDetails.meta.lastChange);
            return;
          }
        }
      }
      console.log('msCard', this.msCard);

      // msCard is in base64 format already
      if (type === 'png') {
        const link = document.createElement('a');
        link.download = `${accreditation._id}.png`;

        // Convert to blob with base64
        const blob = this.dataURItoBlob(this.msCard);
        const blobUrl = URL.createObjectURL(blob);
        // Set the link href to the blob url
        link.href = blobUrl;
        // Append the link to the body
        document.body.appendChild(link);
        // Trigger the click event on the link
        link.click();
      } else if (type === 'pdf') {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        const dd = {
          content: [
            { image: this.msCard, width: [400], alignment: 'center' },
          ],
        };
        pdfMake.createPdf(dd).download(`${accreditation._id}.pdf`);
      } else if (type === 'qr-code') {
        this.showQrCodeDialog = true;
        console.log('this.msCard', this.msCard);
      }
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mimeString });
    },
    async getImageBase64(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.src = url;
      });
    },
    editMember(index) {
      if (!this.editingRows[index]) {
        this.$set(this.editingRows, index, true);
      } else {
        this.$set(this.editingRows, index, false);
      }
    },
    updateMemberStatus(row, index) {
      this.$store.commit('loading', true);
      this.$http
        .put(`/assemble/api/v1/admin/member-accreditations/${row._id}`, { isActive: row.isActive })
        .then(() => {
          this.$set(this.editingRows, index, false);
          this.$message.success('Successful');
          this.$store.commit('loading', false);
        })
        .catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    },
    goToRow(row) {
      this.$router.push({
        name: 'members.update',
        params: { id: row.member._id, accreditation: this.value._id },
      });
    },
    updateDocumentVerification(document) {
      this.$http.put(`assemble/api/v1/admin/accreditations/${this.value._id}/members/${this.currentMember.member._id}/documents/${document._id}/verify`, { verified: document.verified })
        .then(() => {
          this.$message.success('Document verification status updated successfully');
        })
        .catch((error) => {
          this.$message.error(_.get(error, 'response.data.message', 'An error occurred'));
        });
    },
    openDocumentDrawer(member) {
      this.currentMember = member;
      this.documentDrawerVisible = true;
      this.fetchMemberDocuments(member.member._id);
    },
    openUploadDialog() {
      this.uploadDialogVisible = true;
    },
    fetchMemberDocuments(memberId) {
      this.$http.get(`assemble/api/v1/admin/accreditations/${this.value._id}/members/${memberId}/documents`)
        .then((response) => {
          this.memberDocuments = response.data.documents;
          this.key++;
        })
        .catch((error) => {
          this.$message.error(_.get(error, 'response.data.message', 'An error occurred'));
        });
    },
    handleFileUpload(fileUploads) {
      this.$http.post(`assemble/api/v1/admin/accreditations/${this.value._id}/members/${this.currentMember.member._id}/documents`, { fileUploads })
        .then(() => {
          this.$message.success('Documents uploaded successfully');
          this.fetchMemberDocuments(this.currentMember.member._id);
        });
    },
    downloadDocument(document) {
      const { _id } = document;
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/admin/files/${_id}/signed`)
        .then((res) => {
          this.$store.commit('loading', false);
          window.open(res.data.url, '_blank');
        })
        .catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    },
    removeSelectedMember(member) {
      this.selectedMembers = this.selectedMembers.filter((m) => m._id !== member._id);
    },
    dateFormatter(r, c, val) {
      return timedate.set(val).fDate();
    },
    // goToRow(row) {
    //   this.$router.push({ name: 'members.update', params: { id: row.member._id } });
    // },
    bulkAddMembers() {
      this.$http.post(`assemble/api/v1/admin/accreditations/${this.value._id}/members/bulk`, { members: this.selectedMembers })
        .then(() => {
          this.$message.success('Members added successfully');
          this.searchMemberDialogVisible = false;
          this.selectedMembers = [];
          this.$http.get(`assemble/api/v1/admin/accreditations/${this.value._id}/members`)
            .then((res) => {
              this.members = res.data.data;
            });
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    cancelMemberDialog() {
      this.searchMemberDialogVisible = false;
      this.criteria = {};
    },
    handleCurrentChange(val) {
      if (!this.selectedMembers.some((member) => member._id === val._id)) {
        this.selectedMembers.push(val);
      }
    },
    searchCriteria() {
      const { email } = this.criteria;
      if (email && email.length < 3) {
        this.$message.error('Search criteria must have at least 3 characters.');
        return;
      }
      this.search(this.criteria);
    },
    queryChange(queryInfo) {
      this.queryInfo = queryInfo;
      if (this.criteria.email || (this.criteria.firstName && this.criteria.lastName)) {
        this.search(this.criteria);
      }
      if (this.queryInfo) {
        _.assign(this.criteria, { sort: this.queryInfo.sort || {}, onLoad: true });
        this.search(this.criteria);
      }
    },
    search(body) {
      this.$store.commit('loading', true);
      const { pageSize, page } = this.queryInfo;
      this.$http.post(`/assemble/api/v1/admin/my-members/data-table/${pageSize}/${page}/`, body)
        .then((response) => {
          const { total, pageData } = response.data.data;
          this.total = total;
          this.tableData = pageData;
          this.$store.commit('loading', false);
        }).catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    },
    resetSearchResults() {
      this.tableData = [];
      this.total = 0;
      this.search(this.criteria);
    },
  },
  computed: {
    filteredTableData() {
      return this.tableData.filter((member) => !this.members.some((m) => m._id === member._id));
    },
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    idLabel() {
      return +process.env.VUE_APP_NATIONAL_ID === 1 ? 'NSWISA Member ID' : 'Member ID';
    },
  },
  watch: {
    criteria: {
      handler(newCriteria) {
        if (!newCriteria.id && !newCriteria.firstName && !newCriteria.lastName && !newCriteria.email) {
          this.resetSearchResults();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
